/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sp } from './Sp';

class ShopOtoldTemplate extends Sp {
    constructor() {
        super();
        this.baseUrl += '/shopOtoldTemplate';
    }

    data({ templateName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            templateName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({
        id,
        templateName,
        prepareGoodsMode,
        prepareGoodsDesc,
        templateDesc,
        isAvailable,
        regionRangeName,
        regionRange,
        templateMemberLevel,
        shopOtoldTemplateTimeJson,
    } = {}) {
        return super.post('/save', {
            id,
            templateName,
            prepareGoodsMode,
            prepareGoodsDesc,
            templateDesc,
            isAvailable,
            regionRangeName,
            regionRange,
            templateMemberLevel,
            shopOtoldTemplateTimeJson,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable }) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    select() {
        return super.get('/select', {});
    }
}

export default new ShopOtoldTemplate();
export { ShopOtoldTemplate };
